import React from 'react';
import { FadeIn } from './FadeIn';
import { phases } from '../data/landing';
export function PhasesSection() {
  return <section className="py-16 md:py-24 bg-brand-cream" data-id="element-93" data-mp="3788lh1fmk3bf">
      <div className="max-w-6xl mx-auto px-6" data-id="element-94" data-mp="2t9sct4y7c2qn">
        <FadeIn data-id="element-95" data-mp="2t90lw7fjut6p">
          <div className="text-center mb-10 md:mb-14" data-id="element-96" data-mp="2t9ipxq8gebp6">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-forest mb-4" data-id="element-97" data-mp="2xam1w1ndrnl4">
              Así funcionan tus 21 días
            </h2>
            <p className="text-brand-gray text-lg max-w-md mx-auto leading-relaxed" data-id="element-98" data-mp="2jhw4z26bcy98">
              Un recorrido progresivo en 3 fases. No necesitas hacerlo todo a
              la vez.
            </p>
          </div>
        </FadeIn>

        <ol className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-99" data-mp="2ekcr43dj2nht">
          {phases.map((item, index) => <FadeIn key={item.phase} delay={0.05 * index} className="h-full" data-id="element-100" data-mp="20kuxnapaem24" data-mpi={index}>
              <li className="bg-white rounded-2xl p-6 md:p-8 h-full flex flex-col" data-id="element-101" data-mp="25jy3gxd3cwb5">
                <div className="flex items-baseline justify-between mb-5" data-id="element-102" data-mp="1d59ekahcdpk2">
                  <span className="text-xs font-semibold tracking-widest uppercase text-brand-terracotta" data-id="element-103" data-mp="1d7cebm8aqx1z">
                    {item.phase}
                  </span>
                  <span className="text-sm font-medium text-brand-gray" data-id="element-104" data-mp="1n2e3uj6hi153">
                    {item.days}
                  </span>
                </div>
                <h3 className="font-serif font-bold text-2xl text-brand-forest mb-3" data-id="element-105" data-mp="1i2j924jl8rer">
                  {item.title}
                </h3>
                <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-106" data-mp="pggga7d8z5ma">
                  {item.text}
                </p>
              </li>
            </FadeIn>)}
        </ol>

        <FadeIn delay={0.15} data-id="element-107" data-mp="zdcqchisnzsy">
          <p className="text-center text-sm text-brand-gray mt-8 max-w-md mx-auto" data-id="element-108" data-mp="zd2zkrpxdom7">
            Además incluye un capítulo especial, plan de mantenimiento y
            referencias científicas.
          </p>
        </FadeIn>
      </div>
    </section>;
}